import * as React from 'react'
import styled from 'styled-components'
import I18n from 'core/i18n'
import * as constants from 'static/constants'
import { Button, InputText } from 'components/atoms'

interface IImageInput {
  id?: number
  description: string
  image: string | undefined
  image_url: string
  large_url?: string
}
interface IProps {
  images: IImageInput[]
  setImages: React.Dispatch<React.SetStateAction<IImageInput[]>>
}

const MultipleImageInput = ({ images, setImages }: IProps) => {
  const handleDelete = React.useCallback(
    (index: number) => {
      setImages(oldValues => oldValues.filter((_, i) => i !== index))
    },
    [setImages]
  )

  const handleAdd = React.useCallback(() => {
    setImages(oldValues => [...oldValues, { description: '', image: '', image_url: '', id: null }])
  }, [setImages])

  const handleUpdateImages = React.useCallback(
    (index: number, params: Partial<IImageInput>) => {
      setImages(oldValues =>
        index === -1
          ? oldValues
          : [
              ...oldValues.slice(0, index),
              { ...oldValues[index], ...params },
              ...oldValues.slice(index + 1),
            ]
      )
    },
    [setImages]
  )

  const handleFileChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
      const file = e.target.files?.[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = event => {
          handleUpdateImages(index, {
            image: (file as unknown) as string,
            image_url: event.target?.result as string,
          })
        }
        reader.readAsDataURL(file)
      }
    },
    [handleUpdateImages]
  )

  return (
    <Wrapper>
      <hr />
      {images.map((image, index) => (
        <div className="imageItem" key={index}>
          <div className="imageTitle">Photo {index + 1}</div>
          <InputText
            required={false}
            name="description"
            placeholder={I18n.t('guide_report_image.description')}
            value={image.description}
            onChangeHandler={e => handleUpdateImages(index, { description: e.target.value })}
          />
          <input
            type="file"
            id={`image${index}`}
            onChange={e => handleFileChange(e, index)}
            accept="image/*"
          />
          <label htmlFor={`image${index}`} className="imageUpload">
            {image.image_url ? (
              <div>
                <img
                  src={image.image_url}
                  onClick={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    window.open(image.large_url || image.image_url, '_blank', 'noopener,noreferrer')
                  }}
                  title="クリックで写真を別タブに表示"
                />
              </div>
            ) : (
              <Button small={true} fake={true}>
                Upload
              </Button>
            )}
          </label>
          <Button
            small={true}
            textColor={constants.COLORS.white}
            backgroundColor={constants.COLORS.caution}
            handleClick={() => {
              handleDelete(index)
            }}
          >
            {I18n.t('generic.delete')}
          </Button>
        </div>
      ))}
      <div className="addImageBtn">
        <Button small={true} handleClick={handleAdd} disabled={images.length === 3}>
          + {I18n.t('generic.add')} {I18n.t('generic.photo')}
        </Button>
      </div>
    </Wrapper>
  )
}

export default MultipleImageInput

const Wrapper = styled.div`
  .imageItem {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: start;
    margin-top: 16px;
    height: 80px;

    .imageTitle {
      font-size: 14px;
      font-weight: bold;
      margin-right: auto;
    }

    .InputText {
      width: 410px;
    }

    input[type='file'] {
      display: none;
    }

    .imageUpload {
      cursor: pointer;

      button {
        width: 120px;
      }

      img {
        width: 120px;
        height: 80px;
        object-fit: cover;
        border-radius: 6px;
      }
    }
  }

  .addImageBtn {
    display: flex;
    justify-content: end;
    margin: 20px 0;
    button {
      width: 110px;
    }
  }
`
